export class EnrollModel {
  statusCode: string;
  userMessageTitle: string;
  userMessageDesc: string;
  dataErrorWithRetryBtn: boolean;
  
  constructor(
    statusCode: string, 
    userMessageTitle: string,
    userMessageDesc: string,
    dataErrorWithRetryBtn: boolean
  ) {
    this.statusCode = statusCode;
    this.userMessageTitle = userMessageTitle;
    this.userMessageDesc = userMessageDesc;
    this.dataErrorWithRetryBtn = dataErrorWithRetryBtn;
  }
}
